<template>
  <div :class="`dashboard ${isSideNavDisabled && 'no-padding'}`">
    <side-nav />
    <router-view />
  </div>
</template>

<script>
import SideNav from '@/components/SideNav'
export default {
  components: {
    SideNav
  },
  computed: {
    isSideNavDisabled() {
      const path = this.$route.fullPath
      return path.includes('payroll') || path.includes('población') || path.includes('employee')
    }
  }
}
</script>